import Dialog from "@/components/Dialog";
import { t } from "@/utils";
import ErrorIcon from "assets/icons/error.svg?react";
import { warningContentEnum } from "./warningContentEnum";
import { useMemo } from "react";
import { SpecificFeature, FeatureStringKey, useMonitoringWarningDialog } from "./useMonitoringWarningDialog";

type ContentGetParams = {
  specificFeature: SpecificFeature | null | undefined;
  stringKey: FeatureStringKey | null | undefined;
};

const getContent = ({ specificFeature, stringKey }: ContentGetParams) => {
  const content = warningContentEnum;
  if (specificFeature === "face" && stringKey)
    return {
      title: content[specificFeature][stringKey as keyof (typeof content)["face"]].title,
      body: content[specificFeature][stringKey as keyof (typeof content)["face"]].subtitle,
      icon: content[specificFeature][stringKey as keyof (typeof content)["face"]].Icon
    } as const;
  if (specificFeature === "microphone" && stringKey)
    return {
      title: content[specificFeature][stringKey as keyof (typeof content)["microphone"]].title,
      body: content[specificFeature][stringKey as keyof (typeof content)["microphone"]].subtitle,
      icon: content[specificFeature][stringKey as keyof (typeof content)["microphone"]].Icon
    } as const;
  else
    return {
      title: "somethingWentWrong",
      body: "tryAgainLater",
      icon: ErrorIcon
    } as const;
};

export default function MonitoringWarningDialog() {
  const { isOpen, close, specificFeature, stringKey } = useMonitoringWarningDialog();
  const { title, body, icon } = useMemo(() => getContent({ specificFeature, stringKey }), [specificFeature, stringKey]);
  return (
    <Dialog
      isOpen={isOpen}
      onClose={close}
      title={t(title)}
      body={t(body)}
      buttons={{ confirm: { label: t("buttons.ok") } }}
      iconProps={{ fill: "error", size: "2rem" }}
      icon={icon}
    />
  );
}
